import * as React from 'react';
import { SVGProps } from 'react';

const IconVolumeDownSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.115 2.147 4 4H3a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h1l2.115 1.853c.326.315.885.092.885-.353v-7c0-.445-.559-.668-.885-.353ZM9.854 3.147a.5.5 0 1 0-.708.707c.413.412.854 1.288.854 2.142 0 .856-.442 1.739-.854 2.15a.5.5 0 1 0 .708.708C10.442 8.266 11 7.134 11 5.996c0-1.138-.56-2.262-1.146-2.85Z" />
  </svg>
);
export default IconVolumeDownSizeXs;
